import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';
import styled from '@react-pdf/styled-components';

const Description = styled.Text`
  text-align: left;
  width: '100%';
  font-size: 9px;
`;

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 0,
  },
  row: {
    flexDirection: 'row',
    height: 16,
  },
});

const PdfMessageBcalc = ({ dat }: any) => {
  return (
    <View style={styles.tableContainer}>
      <View style={styles.row}>
        <Description></Description>
      </View>
      <View style={styles.row}>{dat.aNotes && <Description>{dat.aNotes.pdfmessa}</Description>}</View>
      <View style={styles.row}>{dat.aNotes && <Description>{dat.aNotes.pdf_head1}</Description>}</View>
      <View style={styles.row}>{dat.aNotes && <Description>{dat.aNotes.pdf_head2}</Description>}</View>
      <View style={styles.row}>
        {dat.aNotes && (
          <Description>
            {dat.aNotes.pdfmess1} {dat.aNotes.pdfmess2}
          </Description>
        )}
      </View>
      <View style={styles.row}>
        {dat.aNotes && (
          <Description>
            {dat.aNotes.pdfmess3} {dat.aNotes.pdfmess4}
          </Description>
        )}
      </View>
      <View style={styles.row}>
        {dat.aNotes && (
          <Description>
            {dat.aNotes.pdfmess5} {dat.aNotes.pdfmess6}
          </Description>
        )}
      </View>
      <View style={styles.row}>
        {dat.aNotes && (
          <Description>
            {dat.aNotes.pdfmess7} {dat.aNotes.pdfmess8}
          </Description>
        )}
      </View>
      <View style={styles.row}>{dat.bCalc && <Description></Description>}</View>
      <View style={styles.row}>{dat.bCalc && <Description>{dat.bNotes.pdfmessb}</Description>}</View>
      <View style={styles.row}>
        {dat.bCalc && (
          <Description>
            {dat.bNotes.pdfmess9} {dat.bNotes.pdfmess10}
          </Description>
        )}
      </View>
      <View style={styles.row}>
        {dat.bCalc && (
          <Description>
            {dat.bNotes.pdfmess11} {dat.bNotes.pdfmess12}
          </Description>
        )}
      </View>
      <View style={styles.row}>{dat.bCalc && <Description>{dat.bNotes.pdfmess12a}</Description>}</View>
      <View style={styles.row}>{dat.bNotes.pdfmess13 != '-0-' && <Description>{dat.bNotes.pdfmess13}</Description>}</View>
      <View style={styles.row}>{dat.bCalc && <Description>{dat.bNotes.pdf_bottom}</Description>}</View>
    </View>
  );
};

export default PdfMessageBcalc;
